module.exports = __webpack_public_path__ + "static/media/xlsx.a71d4666.png";